import { useRef, createRef, useContext } from 'react'
import { useRouter } from 'next/router'
import PropTypes from 'prop-types'

// Internal components
import AccountMenu from '../AccountMenu/AccountMenu'
import CalendarNavigation from '../CalendarNavigation/CalendarNavigation'
import MainMenu from '../MainMenu/MainMenu'
import MetaMenu from '../MetaMenu/MetaMenu'
import OverviewMenu from '../OverviewMenu/OverviewMenu'
import SiteLogo from '../SiteLogo/SiteLogo'
import { AppContext } from '../../context/AppContext'

const Navigation = (props) => {
  // Router
  const router = useRouter()

  // Context
  const AppState = useContext(AppContext)

  // refs
  const scrollObserverRef = createRef(null)
  const navigationRef = useRef(null)
  const containerRef = useRef(null)

  // consts
  const overviewRoute = router.asPath.includes('/overview')
  const calendarRoute =
    router.asPath.includes('/calendar') &&
    !router.asPath.includes('/calendar/select-training') &&
    !router.asPath.includes('/calendar/select-exercise')

  const accountPage = router.asPath.startsWith('/account/')

  return (
    <nav className={`Navigation ${accountPage ? 'Navigation--account' : ''}`} ref={navigationRef}>
      {!accountPage && <div className="Navigation-scrollObserver" ref={scrollObserverRef} />}
      <div className="Navigation-container" ref={containerRef}>
        <div className="Navigation-navbar Navigation-navbar--sitelogo">
          <div className="Navigation-wrapper">
            <SiteLogo ref={[scrollObserverRef, containerRef]} />
          </div>
        </div>
        <div className="Navigation-navbar Navigation-navbar--metamenu">
          <div className="Navigation-wrapper">
            <MetaMenu topBarLinks={props.topBarLinks} />
          </div>
        </div>
        <div className="Navigation-navbar Navigation-navbar--mainmenu">
          <div className="Navigation-wrapper">
            <MainMenu />
          </div>
        </div>
        <div className="Navigation-navbar Navigation-navbar--accountmenu">
          <div className="Navigation-wrapper">
            <AccountMenu />
          </div>
        </div>
        {overviewRoute && !AppState.isRestricted && (
          <div className="Navigation-navbar Navigation-navbar--overview">
            <div className="Navigation-wrapper">
              <OverviewMenu />
            </div>
          </div>
        )}
        {calendarRoute && !AppState.isRestricted && (
          <div className="Navigation-navbar Navigation-navbar--overview">
            <div className="Navigation-wrapper">
              <CalendarNavigation />
            </div>
          </div>
        )}
      </div>
    </nav>
  )
}

Navigation.propTypes = {
  topBarLinks: PropTypes.array
}

export default Navigation
